import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';

import {
	GetAddressByZipCode,
	GetAddressByZipCodeRequest,
	GetAddressByZipCodeResponse,
} from 'domain/usecases';

export class RemoteGetAddressByZipCode implements GetAddressByZipCode {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetAddressByZipCodeResponse>,
	) {}

	async get(params: GetAddressByZipCodeRequest): Promise<GetAddressByZipCodeResponse> {
		const {signal, ...otherParams} = params;

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params: otherParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
